import React, { useState } from "react";
import cn from "classnames";
import styles from "./NameAndDescription.module.sass";

// Screens
import CompanyInformations from "./CompanyInformations";
import AddressInformations from "./AddressInformations";
import AddressMap from "./AddressMap";
import DirectorInformations from "./DirectorInformations";
import ContactInformations from "./ContactInformations";

// Services
import { updateProspectCompany, getProspectCompanyById } from "../../../services/prospectCompany.service";
import { showSuccess, showError } from "../../../services/toast.service";

const NameAndDescription = ({ company }) => {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [companyData, setCompanyData] = useState(company || {});
  const [modified, setModified] = useState(false);

  // Mettre à jour les données de l'entreprise quand le prop change
  React.useEffect(() => {
    if (company) {
      setCompanyData(company);
    }
  }, [company]);

  const handleCompanyChange = (e) => {
    const { name, value } = e.target;
    setCompanyData((prev) => ({ ...prev, [name]: value }));
    setModified(true);
  };

  const handleDropdownChange = (name, option) => {
    const value = option ? option.value : '';
    setCompanyData((prev) => ({ ...prev, [name]: value }));
    setModified(true);
  };

  const handleEditorChange = (name, value) => {
    setCompanyData((prev) => ({ ...prev, [name]: value }));
    setModified(true);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError(null);

    try {
      await updateProspectCompany(companyData.id, companyData);
      
      // Rafraîchir les données de l'entreprise après la mise à jour
      try {
        const refreshedCompany = await getProspectCompanyById(companyData.id);
        setCompanyData(refreshedCompany);
        console.log('Données de l\'entreprise rafraîchies après mise à jour');
      } catch (refreshError) {
        console.error('Erreur lors du rafraîchissement des données:', refreshError);
        // Ne pas faire échouer l'opération si le rafraîchissement échoue
      }
      
      showSuccess("Entreprise mise à jour avec succès!");
      setModified(false);
    } catch (err) {
      const errorMessage =
        "Impossible de mettre à jour l'entreprise: " +
        (err.message || "Veuillez vérifier les informations saisies.");
      showError(errorMessage);
      setError(errorMessage);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className={styles.container}>
      <div className={styles.formContainer}>
        {error && <div className={styles.error}>{error}</div>}
        <form onSubmit={handleSubmit}>
          <CompanyInformations
            company={companyData}
            onCompanyChange={handleCompanyChange}
            onDropdownChange={handleDropdownChange}
          />
          <AddressInformations
            company={companyData}
            onCompanyChange={handleCompanyChange}
          />
          <AddressMap company={companyData} />
          <DirectorInformations
            company={companyData}
            onCompanyChange={handleCompanyChange}
            onDropdownChange={handleDropdownChange}
          />
          <ContactInformations
            company={companyData}
            onCompanyChange={handleCompanyChange}
            onDropdownChange={handleDropdownChange}
            onEditorChange={handleEditorChange}
            modified={modified}
            loading={loading}
          />
        </form>
      </div>
    </div>
  );
};

export default NameAndDescription;
